module.exports = __webpack_public_path__ + "img/hubei.1fc63605.jpg";